<template lang='pug'>
  blue-layout(:user='user' :account='account' :biz='biz')
    template(v-slot:default='props')
      base-modal#filterable-dialog( :show='show.filterable' )
        modal-wrapper( @close='show.filterable = false' )
          template(v-slot:header)
            h5 {{ $t('Manage Customer Types') }}
          
          template(v-slot:contents)
            .categories
              bf-flex.centered.new.category
                .left
                  input(type='checkbox' ref='new' v-model='filter.active' hidden)
                  bf-flex.centered.check-circle(@click.native='$refs.new.click()' :class='{ active: filter.active }')
                    check-icon(v-show='filter.active')
                .center
                  bf-input.basic
                    input(type='text' :placeholder= "$t('Type Something Here')" v-model='filter.title')
                .right.actionable(@click='set')
                  add-icon
              bf-flex.centered.category(v-for='item, i in filters' :key='item.id')
                .left
                  bf-flex.centered.check-circle(@click.native='activate(item)' :class='{ active: item.active }')
                    check-icon(v-show='item.active')
                .center
                  bf-input.basic
                    input(type='text' v-model='item.title' @change='update(item)')
                .right.actionable( @click='remove(item)' )
                  remove-icon

      base-modal#single-customer-dialog(:show='show.single' :scrolled='props.scrolled')
        modal-wrapper( @close='show.single = false' )
          template(v-slot:header)
            h5 {{ $t("Add Customer") }}

          template(v-slot:contents)
            new-customer-form( :biz='biz' :customers='customers' :account='account' )

      base-modal#add-via-qr-dialog(:show='show.qr' :scrolled='props.scrolled')
        modal-wrapper( @close='show.qr = false' )
          template(v-slot:header)
            h5 {{ $t("QR Code & Message")}}

          template(v-slot:contents)
            h5.link-container
              span.link( ref='link' ) {{ `https://app.bluefaucet.com/m/${biz.id}` }}
              span.copy-icon.actionable( v-clipboard='`https://app.bluefaucet.com/m/${biz.id}`' @click='copymsg')
                img(src='/ui/copy.svg' width='20')

            bf-wrapper.tiny
              form
                qr-code.qr-code( :value="`https://app.bluefaucet.com/m/${biz.id}`" :options="{ width: 192 }" )

                h4.heading {{ $t('Invitation Message') }}

                p {{ $t('You may copy and paste the following message') }}
                p {{ $t('which will include your dedicated URL and send it to invite your customers') }}

                textarea( v-model='cmessage.msg' )

                bf-button.basic( v-clipboard='msg' @click.native='copy' :key='msg' )
                  template(v-slot:text) {{ $t('Save and Copy') }}

      base-modal#bulk-upload-dialog(:show='show.bulk' :scrolled='props.scrolled')
        modal-wrapper(@close='show.bulk = false')
          template(v-slot:header)
            h4 {{ $t('Bulk Import') }}
          template(v-slot:contents)
            form(@submit.prevent='bulk')
              bf-input.basic
                textarea(v-model='customer.invitation.message' :placeholder='$t("Your invitation message")')

              bf-flex.form-buttons.space-between
                bf-button.full.clear(type='submit' @click.native='customer.invitation.invited = false')
                  template(v-slot:text) {{ $t('Import') }}
                bf-button.full(type='submit' @click.native='customer.invitation.invited = true')
                  template(v-slot:text) {{ $t('Import and Send Invitation') }}

      #customers.view.no-header
        bf-notice(:message='message' @close='message=""')
        bf-wrapper.content
          section#search-filters
            bf-flex.centered
              label {{ $t("Category: ")}}

              select.custype( v-model='selected' )
                option( value='all' ) {{ $t('Display All') }}
                option( v-for='filter in active' :value='filter' ) {{ filter.title }}
              
              bf-button.edit( @click.native='show.filterable = true' )
                template( v-slot:text ) {{ $t('Manage') }}
              
              bf-input.search.icon-right( v-if='1==0' )
                template( v-slot:icon )
                  .icon
                    search-icon
                input( type='search' )

          bf-divider.card

          section#add-customer
            bf-flex
              bf-button.clear.add-button(@click.native='show.single = true')
                template(v-slot:icon)
                  new-icon.icon2
                  p {{ $t("Add Customer")}}
              bf-button.clear.qr-button(@click.native='show.qr = true')
                template(v-slot:icon)
                  qr-icon.icon2
                  p {{ $t("QR Code & Message")}}
              bf-button.clear.import(v-if="1==0" @click.native='show.bulk = true')
                template(v-slot:icon)
                  bulk-icon
                  p {{ $t("Bulk Import")}}
          
          section#list
            bf-flex.centered.tabs
              .tab
                router-link( :to='{ name: "acquired" }') {{$t("Customer")}}
                span.count {{ count }}
              .tab
                router-link( :to='{ name: "prospects" }') {{$t("Invited")}}
              .tab
                router-link( :to='{ name: "fans" }') {{$t("Favorite")}}
            
            router-view( 
              v-if='user && biz.id' 
              :items='filtered' 
              :user='user' 
              :biz='biz'
              :rsvs='reservations'
              :account='account'
              :filters='active'
            )
</template>

<script>
  import { View } from '@/mixins/view'
  import { db } from '@/main'
  import QrCode from '@chenfengyuan/vue-qrcode'
  import BaseModal from '@/components/modals/base'
  import ModalWrapper from '@/components/modals/wrapper'
  import NewCustomerForm from '@/components/forms/customers/new'
  import CopyIcon from 'vue-material-design-icons/ContentCopy'

  export default {
    name: 'customers.view',

    mixins: [View],

    components: {
      QrCode,
      BaseModal,
      ModalWrapper,
      NewCustomerForm,
      CopyIcon
    },

    data() {
      return {
        cmessage: { msg: '' },
        message: '',
        customers: [],
        filter: { active: true },
        filters: [],
        show: { filterable: false, single: false, qr: false, bulk: false },
        selected: 'all', // the selected filter
        qr_type: 'default',
        customercard: false,
        reservations: [],
        customer: { invitation: {invited: false, message: ''}, phone: '', email: '' }
      }
    },

    firestore() {
      if ( this.biz && this.biz.id ) return {
        filters: {
          ref: db.collection('filters').where( 'account_id', '==', this.account.id )
        },
        reservations: {
          ref: db.collection('reservations').where( 'business_id', '==', this.biz.id )
        },
        customers: {
          ref: db.collection( 'customers' ).where( 'business_id', '==', this.biz.id )
        }
      }

      else if ( this.user ) return {
        cmessage: db.collection( 'copies' ).doc( this.user.uid )
      }
    },

    computed: {
      count() {
        return this.customers.filter( c => this.reservations.map( r => r.account_id ).includes( c.account_id ) ).length
      },

      filtered() {
        if ( this.selected == 'all' ) return this.customers
        else return this.customers.filter( s => s.filter && s.filter.id == this.selected.id )
      },

      active() {
        return this.filters.filter( f => f.active )
      },

      bmessage() {
        return `Click Here to check out my page: https://app.bluefaucet.com/m/${this.biz.id}` + "\n\n" + `Or signup directly at: https://app.bluefaucet.com/m/${this.biz.id}`
      },

      msg() {
        return `${this.cmessage.msg}` + "\n\n" +  `${this.bmessage}`
      }
    },

    watch: {
      account( curr, prev ) {
        if ( curr.id ) {
          this.$binding( 'filters', db.collection('filters').where( 'account_id', '==', this.account.id ) )
          this.$binding( 'cmessage', db.collection( 'copies' ).doc( this.user.uid ) )
        }
      },

      biz( curr, prev ) {
        if ( curr && curr.id ) {
          this.$binding( 'customers', db.collection('customers').where( 'business_id', '==', curr.id ) )
          this.$binding( 'reservations', db.collection('reservations').where( 'business_id', '==', curr.id ) )
        }
      },

      user( curr, prev ) {
        if ( curr ) this.$binding( 'cmessage', db.collection( 'copies' ).doc( curr.uid ) )
      },

      customers( curr, prev ) {
        curr.forEach( c => {
          if ( c.account_id && !c.account ) db.collection( 'accounts' ).doc( c.account_id ).get().then( doc =>
            db.collection( 'customers' ).doc( c.id ).update({
              account: { ...doc.data(), ...{id: doc.id} }
            })
          )
        })
      }
    },

    methods: {
      copy() {
        db.collection( 'copies' ).doc( this.user.uid ).set({ msg: this.cmessage.msg }).then( () =>
          alert(this.$t('Message copied to clipboard'))
        )
      },

      copymsg(){
        alert(this.$t(this.$t('URL copied to clipboard')))
      },

      remove(item) {
        db.collection( 'filters' ).doc( item.id ).delete()
      },

      notify(msg) {
        console.log('full message', this.message + msg )
        this.message = this.message + msg
      },

      invite() {
        this.customers.filter( c => !c.invitation.joined ).forEach( prospect => {
          prospect.invitation.sent = new Date()
          db.collection( 'customers' ).doc( prospect.id ).set( prospect, { merge: true } ).then( () =>
            this.notify(this.$t('Invitation has been sent'))
          )
        })
      },

      set() {
        this.filter.account_id = this.account.id
        db.collection('filters').add( this.filter ).then( () => this.filter = { active: true } )
      },

      set_customer(c) {
        db.collection( 'customers' ).doc( c.id ).set( c, { merge: true } )
      },

      activate(item) {
        item.active = !item.active
        this.update(item)
      },

      update(item) {
        db.collection('filters').doc( item.id ).set( item, {merge: true} )
      }
    }
  }
</script>

<style scoped lang='stylus'>
  label 
    font-weight bold
    margin-right 10px
  .custype
    background rgb( 240 240 240 )
    border-radius 5px
    border 1px solid lightgray
    
  .heading
    padding 0 16px
    margin-bottom 20px

  #list
    background rgb(240 240 240)
    padding 5px
    margin-top 5px
    border-radius 5px
    .tabs
      margin 20px 0
      font-size 1.2em
      font-weight bold
      color rgb( 60 60 60 )
      .tab
        border-left 1px solid
        &:first-child
          border 0
      a
        padding 4px 12px
        margin 0 12px
      .count
        margin-right 12px
        color red

      .router-link-exact-active
        border-radius 5px
        background orange
        color white

  #bulk-upload-dialog
    border 1px solid black
    border-radius 5px
    box-shadow var(--shadow-box)
    .bf-button
      margin-top 10px
    
  #add-via-qr-dialog
    text-align center
    .qr-code
      width 100%
    .message
      margin 10px 0
    .link-container
      position relative
      margin 0 auto
      text-align center
      max-width 800px
      .link
        color var(--clr-blue)
      .copy-icon
        position absolute
        margin-left 10px

    textarea
      height 150px
      text-align left

  #single-customer-dialog
    .vue-tel-input
      border 0
    .form-buttons
      margin 32px 0

  #filterable-dialog
    // .filterable
    //   padding 32px
    //   background white
    //   border-radius 9px
    //   min-width 400px
    //   max-width 420px
    //   @media( max-width: 480px )
    //     min-width 0
    //   .close
    //     position absolute
    //     right -6px
    //     top -6px
    //     background white
    // .categories
    //   margin-top 36px

    .category
      margin-top 16px
      &:first-child
        margin 0
      // input[type=text]
      //   width 100%
      &.new
        .right
          font-size 2.25em
          padding 0
        .left
          padding 0
          margin-right 4px
      .right
        font-size 1.8em
        color rgb( 55 70 100 )
        text-align right
        padding 0 3px
        padding-left 6px
      .left
        padding-right 3px
      .center
        flex-grow 1
        margin 0 4px
    .check-circle
      border-radius 50%
      border 1px solid
      height 12px
      width 16px
      padding-bottom 4px
      &.active
        background rgb( 100 150 75 )
        color white
        border-color rgb( 100 150 75 )

  #search-filters
    select
      width auto
      margin 0
    .edit
      margin-left 12px
    .search
      margin-left auto
      width 128px

  #add-customer
    .bf-flex
      justify-content space-between
    .bf-button
      font-size 1em
      margin-left 8px
      padding 4px 12px
      &:first-child
        margin-left 0
      .icon2
        margin-right 5px
        vertical-align middle

  #list-customers
    margin-top 24px
    .customer
      position relative
      padding 12px
      margin 16px 0
      font-size .8em
      &:first-child
        margin-top 0
      section
        margin-top 16px
      .cover
        position absolute
        top -1px
        left 0
        border-radius 5px
        height 100.5%
        width 100%
        background rgba( 240 240 240 .64 )
        z-index 1
      .delete
        width 12px
        font-size 1.5em
        position relative
        margin-bottom auto
        z-index 2
      .avatar
        width 42px
        height 42px
        border-radius 50%
      .details
        margin-left 16px
      .filters
        width 96px
        margin-left auto
        // margin-right 16px
        select
          padding 0
          width auto
        .last-visit
          font-size .88em
          margin-top 8px
</style>
